import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import React, { useEffect, useState } from "react";
import { FooterPrice, FooterText } from "./styles";
import CloneChildren from "@components/children";
import { connect, useSelector } from "react-redux";
import { getWidgetSpecificProps } from "@utils/index";
import { getInrFormat } from "@utils/inrFormatter";
import Tooltip from "@components/tooltip";
import { useRouter } from "next/router";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const FooterData = (props) => {
  const { price, gstText, modalText, children, actions, preText, tooltipText, wrapperStyles } = props || {};
  const { on_click } = actions || {};
  const router = useRouter();
  const { proposal_ekey } = router?.query;

  const { selectedPrice, idvPrice } = useSelector(({ globalState }: any) => {
    return {
      selectedPrice: globalState?.price,
      idvPrice: globalState?.idv_price
    };
  });

  const hanldeTextClicked = () => {
    if (on_click?.[0] && typeof on_click[0].funCall === "function") {
      on_click?.forEach(async (eachFunc: any) => {
        const payload = {
          ...eachFunc.args
        };
        console.log("onclick", payload, eachFunc);
        const res = await eachFunc.funCall(payload);
      });
    }
  };

  const displayPrice = selectedPrice || price;

  const [displayNetPremium, setDisplayNetPremium] = useState(null);

  useEffect(() => {
    if (idvPrice > 0) {
      const numericDisplayPrice =
        typeof displayPrice === "string"
          ? parseFloat(displayPrice.replace(/[^0-9.-]+/g, ""))
          : displayPrice;
      setDisplayNetPremium(numericDisplayPrice + idvPrice);
    } else {
      setDisplayNetPremium(displayPrice);
    }
  }, [idvPrice, displayPrice]);

  const formattedDisplayPrice =
    typeof displayNetPremium === "string"
      ? displayNetPremium
      : getInrFormat(displayNetPremium);

  return (
    <>
      {price ? (
        <Flex flexDirection="column" alignItems="flex-start" width="100%">
          <Flex flexDirection="column">
            {preText && (
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: "#5B5675",
                  marginBottom: "2px"
                }}
              >
                {preText}
              </span>
            )}
            <div style={{ position: "relative" }}>
              {tooltipText ? (
                <Tooltip
                  content={tooltipText}
                  shouldShowOnce
                  sessionKey={`tooltip-${proposal_ekey}`}
                >
                  <FooterPrice>
                    {formattedDisplayPrice}
                    {gstText && (
                      <span style={{ marginLeft: "4px" }}> {gstText}</span>
                    )}
                  </FooterPrice>
                </Tooltip>
              ) : (
                <FooterPrice>
                  {formattedDisplayPrice}
                  {gstText && (
                    <span style={{ marginLeft: "4px" }}> {gstText}</span>
                  )}
                </FooterPrice>
              )}
            </div>
          </Flex>

          {(() => {
            const match =
              typeof modalText === "string"
                ? modalText.match(/^₹([\d,]+) less than last year$/)
                : null;

            if (match) {
              const amount = parseInt(match[1].replace(/,/g, ""), 10);
              if (amount === 0) return null;

              return (
                <FooterText
                  wrapperStyles={wrapperStyles}
                  style={{ color: "#5B5675" }}
                  onClick={hanldeTextClicked}
                >
                  <span
                    style={{ color: "#0FA457" }}
                  >{`₹${match[1]} less`}</span>
                  {` than last year`}
                </FooterText>
              );
            }

            return (
              <FooterText onClick={hanldeTextClicked}>{modalText}</FooterText>
            );
          })()}
          <Box>
            <CloneChildren
              styles={{
                ...props.style
              }}
              children={children}
              props={props}
            />
          </Box>
        </Flex>
      ) : (
        <></>
      )}
    </>
  );
};

export default connect(mapStateToProps)(FooterData);
